<template>
    <a-result status="403" title="403" sub-title="对不起，没有权限访问当前页面">
        <template #extra>
            <a-button type="primary" @click="backHome">回到首页</a-button>
        </template>
    </a-result>
</template>

<script>
export default {
    name: "403",
    methods:{
        backHome(){
            this.$router.replace('/');
        }
    }
}
</script>

<style scoped>

</style>
